// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ik","summaryPar":"jk","ratingCategories":"kk","reviewerInfo":"lk","reviewTypes":"mk","expanded":"nk"};